import { MaintenanceTask } from './maintenance/MaintenanceTask.model';

export class MaintenanceTaskDTO {
    name: string;
    description: string;
    periodNumber: number;
    periodType: string;
    createdById: number;
    maintenanceTaskCategoryId: number;
    showId: number;

    public static createFromMaintenanceTask(maintenanceTask: MaintenanceTask): MaintenanceTaskDTO {
        const instance = new MaintenanceTaskDTO();
        instance.name = maintenanceTask.name;
        instance.description = maintenanceTask.description;
        instance.periodNumber = maintenanceTask.periodNumber;
        instance.periodType = maintenanceTask.periodType;
        instance.maintenanceTaskCategoryId = maintenanceTask.maintenanceTaskCategory.id;
        return instance;
    }
}

export enum MaintenanceTaskPeriodType {
    day = 'DAY',
    week = 'WEEK',
    month = 'MONTH',
    year = 'YEAR'
}
